import { createSelector } from '@ngrx/store';

import * as fromFeature from '../reducers';
import * as fromFaqCategories from '../reducers/faq-category.reducer';

export const getCategoriesState = createSelector(fromFeature.getLandingState, (state: fromFeature.FaqCategoriesState) => state.categories);

// export const getFaqCategoriesState = createSelector(
//   fromFeature.getLandingState,
//   (state: fromFeature.FaqCategoriesState) => state.categories
// );

export const getFaqCategoriesEntities = createSelector(getCategoriesState, fromFaqCategories.getFaqCategoriesEntities);

export const getAllFaqCategories = createSelector(getFaqCategoriesEntities, entities => {
  return Object.keys(entities).map(slug => entities[slug]);
});

export const getOrderedFaqCategories = createSelector(getAllFaqCategories, categories => {
  return categories.sort(a => a.order);
});

export const getFaqCategoriesLoaded = createSelector(getCategoriesState, fromFaqCategories.getFaqCategoriesLoaded);
export const getFaqCategoriesLoading = createSelector(getCategoriesState, fromFaqCategories.getFaqCategoriesLoading);
